import React from "react";

const plans = [
  {
    price: "₹2,000",
    period: "/ session",
    name: "Relaxation",
    desc: "Perfect for your first spa visit.",
    features: [
      "Swedish Massage",
      "Aroma Therapy",
      "Body Relaxation",
      "Sauna Access",
    ],
    featured: false,
  },
  {
    price: "₹3,500",
    period: "/ session",
    name: "Rejuvenation",
    desc: "Our most popular signature experience.",
    features: [
      "Hot Stone Massage",
      "Deep Tissue",
      "Chakra Balancing",
      "Sauna + Steam",
      "Complimentary Tea",
    ],
    featured: true,
  },
  {
    price: "₹6,000",
    period: "/ session",
    name: "Royal Retreat",
    desc: "The ultimate luxury indulgence.",
    features: [
      "Royal H2O Signature",
      "Thai Sports Massage",
      "Warm Candle Therapy",
      "Full Body Treatment",
      "Geothermal Spa",
      "Priority Booking",
    ],
    featured: false,
  },
];

function Pricing() {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="pricing" style={{ background: "var(--cream)" }}>
      <div style={{ textAlign: "center", marginBottom: 0 }}>
        <div
          className="section-label reveal"
          style={{ justifyContent: "center" }}
        >
          Pricing Packages
        </div>
        <h2 className="section-title reveal">
          Choose Your <em>Perfect Package</em>
        </h2>
      </div>
      <div className="pricing-grid">
        {plans.map((p, i) => (
          <div
            className={`price-card reveal stagger-${i + 1} ${
              p.featured ? "featured" : ""
            }`}
            key={p.name}
          >
            {p.featured && (
              <div
                style={{
                  position: "absolute",
                  top: 20,
                  right: 20,
                  fontSize: ".6rem",
                  letterSpacing: ".2em",
                  textTransform: "uppercase",
                  background: "var(--gold)",
                  color: "var(--deep)",
                  padding: "4px 10px",
                }}
              >
                Most Popular
              </div>
            )}
            <div className="price-tag">
              {p.price}
              <small>{p.period}</small>
            </div>
            <div className="price-name">{p.name}</div>
            <div className="price-desc">{p.desc}</div>
            <ul className="price-features">
              {p.features.map((f) => (
                <li key={f}>{f}</li>
              ))}
            </ul>
            <button
              className="price-btn"
              onClick={() => scrollToSection("contact")}
            >
              Book Now
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Pricing;
